/**
 * HERRAMIENTAS — referencia consultable.
 *
 * Consume el catálogo del curriculum, así que ya está completa: qué hace cada
 * herramienta, por qué está en el programa, cuándo se usa, cuánto y cómo.
 *
 * IMPORTANTE: aquí va la referencia GENERAL. Las instrucciones de la sesión de
 * hoy viven en el paso, nunca acá.
 */

import { CURRICULUM_ACTUAL } from '../../curriculum';
import { FUENTES_LISTENING } from '../../curriculum/v1/fuentesListening';
import { Pantalla } from '../comunes/Pantalla';
import { Suave, Tarjeta } from '../comunes/Tarjeta';
import estilos from './Herramientas.module.css';

export function Herramientas() {
  return (
    <Pantalla titulo="Herramientas" tituloVisible>
      <Suave>
        Todo lo que necesitás saber sobre cada herramienta está acá, para no tener que
        buscarlo en otro documento.
      </Suave>

      {CURRICULUM_ACTUAL.herramientas.map((herramienta) => (
        <Tarjeta key={herramienta.clave}>
          <h2 className={estilos.nombre}>
            <span aria-hidden="true">{herramienta.icono}</span> {herramienta.nombre}
          </h2>

          <dl className={estilos.ficha}>
            <dt>Qué hace</dt>
            <dd>{herramienta.queHace}</dd>
            <dt>Por qué está en el programa</dt>
            <dd>{herramienta.porQue}</dd>
            <dt>Cuándo se usa</dt>
            <dd>{herramienta.cuando}</dd>
            <dt>Tiempo típico</dt>
            <dd>{herramienta.tiempoTipico}</dd>
          </dl>

          <details className={estilos.como}>
            <summary>Cómo se usa</summary>
            <ol>
              {herramienta.comoSeUsa.map((paso) => (
                <li key={paso}>{paso}</li>
              ))}
            </ol>
          </details>

          {herramienta.url ? (
            <a
              className={estilos.abrir}
              href={herramienta.url}
              target="_blank"
              rel="noreferrer noopener"
            >
              Abrir {herramienta.nombre}
            </a>
          ) : (
            <p className={estilos.sinApp}>No necesita ninguna aplicación externa.</p>
          )}

          {herramienta.clave === 'muestraListening' ? (
            <div className={estilos.fuentes}>
              <h3 className={estilos.subtitulo}>Fuentes sugeridas</h3>
              <Suave>
                Ninguna es obligatoria. Si una deja de funcionar, usá otra: lo único que
                hace válida la medición es que el fragmento sea nuevo para vos.
              </Suave>
              <ul>
                {FUENTES_LISTENING.map((fuente) => (
                  <li key={fuente.clave}>
                    <a href={fuente.url} target="_blank" rel="noreferrer noopener">
                      {fuente.nombre}
                    </a>
                    <span className={estilos.transcript}>
                      {fuente.transcript === 'si'
                        ? 'con transcripción'
                        : fuente.transcript === 'a-veces'
                          ? 'a veces con transcripción'
                          : 'sin transcripción'}
                    </span>
                    <p className={estilos.porQueFuente}>{fuente.porQueSirve}</p>
                  </li>
                ))}
              </ul>
            </div>
          ) : null}
        </Tarjeta>
      ))}
    </Pantalla>
  );
}
